<template>
  <button
    class="button"
    :class="{ [`button_${type}`]: true, button_disabled: loading }"
  >
    <loader v-if="loading" size="15px" border="3px" absolute />
    <slot></slot>
  </button>
</template>

<script>
import Loader from '@/components/Loader';

export default {
  props: ['type', 'loading'],
  components: { Loader },
};
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  position: relative;
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid lighten($primary, 20);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: $text-primary;
  cursor: pointer;

  &_primary {
    background-color: $primary;
    color: #fff;
  }

  &_disabled {
    pointer-events: none;
  }
}
</style>
